import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useMergeDictionary = () => {
  return usePost({
    url: ApiRoutesEnum.dictionaryMergeItems,
  });
};
